import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import Person from "components/client-search/Person";

import styles from "./PersonSearchResults.m.scss";

function PersonSearchResults(props) {
  const { theme, data, workWithClient } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.header)}>
        <div>{"Ф.И.О"}</div>
        <div>{"Дата рождения"}</div>
        <div>{"Телефон"}</div>
        <div>{"Паспорт"}</div>
        <div>{"Email"}</div>
        <div className={classnames(theme.controls)} />
      </div>
      {data && data.clients
        ? data.clients.map((person, index) => {
            return (
              <Person
                key={index}
                client={person}
                workWithClient={workWithClient}
                theme={{ wrapper: theme.item }}
              />
            );
          })
        : null}
    </div>
  );
}

PersonSearchResults.displayName = "PersonSearchResults";

PersonSearchResults.propTypes = {
  theme: PropTypes.object,
  data: PropTypes.object,
  workWithClient: PropTypes.func,
};

PersonSearchResults.defaultProps = {};

export default themr("@lifepay/PersonSearchResults", styles)(PersonSearchResults);



// WEBPACK FOOTER //
// ./src/components/client-search/PersonSearchResults/PersonSearchResults.js